const DownloadFile = (fileUrl) => {
  let download = document.createElement('a')
  download.href = fileUrl
  download.download = fileUrl
  download.target = '_blank'
  document.body.appendChild(download)
  download.click()
  document.body.removeChild(download)
}

export default DownloadFile
